<glxy-form-field>
  <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.ENABLE_MEETING_BOOKING.LABEL' | translate }}</glxy-label>
  <mat-select
    [value]="selectedCalendar()"
    [compareWith]="compareCalendars"
    (selectionChange)="onSelection($event)"
    [disabled]="configurationForm().disabled"
  >
    @for (calendar of calendarsTypesThatListAssociations$ | async; track calendar) {
      @if ((calendar?.associations?.length ?? 0) > 0) {
        <mat-optgroup [label]="calendar.name" class="calendar-optgroup">
          @for (type of calendar.associations; track type) {
            <mat-option [value]="{ id: type.meetingTypeId, calendarType: calendar.calendarType }">
              <mat-icon>{{ calendar.icon }}</mat-icon>
              {{ type.name }}
            </mat-option>
          }
        </mat-optgroup>
      }
    }

    @let serviceCalendars = serviceCalendars$ | async;
    @if ((serviceCalendars?.length ?? 0) > 0) {
      <mat-optgroup
        [label]="'AI_ASSISTANT.SETTINGS.ENABLE_MEETING_BOOKING.SERVICE' | translate"
        class="calendar-optgroup"
      >
        @for (calendar of serviceCalendars; track calendar) {
          <mat-option [value]="{ calendarType: calendar.calendarType, id: calendar.id }">
            <mat-icon>{{ calendar.icon }}</mat-icon>
            {{ calendar.name }}
          </mat-option>
        }
      </mat-optgroup>
    }

    <mat-option [value]="null" (click)="goToMeetings()" class="create-new-calendar">
      <span class="option-text">
        {{ 'AI_ASSISTANT.SETTINGS.ENABLE_MEETING_BOOKING.MANAGE_EVENT_LINKS' | translate }}
      </span>
    </mat-option>
  </mat-select>
</glxy-form-field>
